import {
    FileImageOutlined,
    FilePdfOutlined,
    UploadOutlined,
} from "@ant-design/icons";
import { Button, Space, Upload, Typography } from "antd";

const { Dragger } = Upload;
const { Text } = Typography;

export default function GeneralUploader({
    type = "img", // "img" or "pdf"
    onChange,
    onChangeInfo,
    fileList,
    beforeUpload,
    accept,
    multiple = true,
    children,
    ...rest
}) {
    const isPDF = type === "pdf";

    const finalBeforeUpload = beforeUpload || (() => false);
    const finalAccept = accept || (isPDF ? "application/pdf" : "image/*");

    const handleChange = (info) => {
        const files = info?.fileList ?? [];
        onChange?.(files);
        onChangeInfo?.(info);
    };

    return (
        <Dragger
            style={{ padding: "40px 120px" }}
            accept={finalAccept}
            multiple={multiple}
            beforeUpload={finalBeforeUpload}
            onChange={handleChange}
            {...(fileList !== undefined ? { fileList } : {})}
            {...rest}
        >
            <Space
                direction="vertical"
                size={24}
                style={{ width: "100%", textAlign: "center" }}
            >
                {isPDF ? (
                    <FilePdfOutlined
                        style={{ fontSize: 64, color: "#bfbfbf" }}
                    />
                ) : (
                    <FileImageOutlined
                        style={{ fontSize: 64, color: "#bfbfbf" }}
                    />
                )}

                <Button type="primary" icon={<UploadOutlined />} size="large">
                    Upload from device
                </Button>

                <Text type="secondary">
                    {isPDF
                        ? "You can upload one or more PDFs. Drag them here, or click to select."
                        : "You can upload one or more images. Drag them here, or click to select."}
                </Text>

                {children}
            </Space>
        </Dragger>
    );
}
